import { render, staticRenderFns } from "./ProductFacetFilterMobile.vue?vue&type=template&id=28fbc112&scoped=true"
import script from "./ProductFacetFilterMobile.vue?vue&type=script&lang=js"
export * from "./ProductFacetFilterMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductFacetFilterMobile.vue?vue&type=style&index=0&id=28fbc112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fbc112",
  null
  
)

export default component.exports